import React, { useEffect } from 'react'

import { Box, Checkbox, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import { useTaskWizard } from 'modules/processes/components/ItemWizard/Tasks/TaskProvider'

const RequestEsignature = () => {
  const { setTaskConfiguration } = useTaskWizard()
  const { itemType } = useItemProvider()
  const { originalItem, form } = useFormProvider()

  const currentTaskConfiguration = form.get('task_type_configuration')?.value

  const [requestEsignature, setRequestEsignature] = React.useState(true)

  const updateEsignature = () => {
    setTaskConfiguration({
      request_esignature: requestEsignature,
    })
  }

  const setConfigurationSignature = () => {
    if (currentTaskConfiguration?.request_esignature !== undefined) {
      setRequestEsignature(currentTaskConfiguration?.request_esignature)
    } else if (originalItem) {
      const itemConfiguration = JSON.parse(String(originalItem.taskTypeConfiguration))

      if (itemConfiguration?.request_esignature !== undefined) {
        setRequestEsignature(itemConfiguration?.request_esignature)
      }
    } else {
      updateEsignature()
    }
  }

  useEffect(() => {
    setConfigurationSignature()
  }, [])

  useEffect(() => {
    setConfigurationSignature()
  }, [itemType])

  useEffect(() => {
    updateEsignature()
  }, [requestEsignature])

  return (
    <Box gap="s2">
      <Checkbox
        label={i18n.t(
          'processes.process_settings.tasks.form.super_tasks_module.send_document.request_esignature.label'
        )}
        checked={requestEsignature}
        onChange={(event) => setRequestEsignature(event.target.checked)}
      />
      <Text.Normal size="200" weight="medium" color="grey800">
        {i18n.t(
          'processes.process_settings.tasks.form.super_tasks_module.send_document.request_esignature.description'
        )}
      </Text.Normal>
    </Box>
  )
}

export default RequestEsignature
